import { useEffect, useRef, useState } from 'react'

const TOOLTIP_AUTO_CLOSE_TIME = 4000

export const useConfirmButtonTooltip = (condition: boolean) => {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const [showTooltip, setShowTooltip] = useState(false)

  useEffect(() => {
    if (condition) {
      setShowTooltip(true)

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      timeoutRef.current = setTimeout(() => {
        setShowTooltip(false)
      }, TOOLTIP_AUTO_CLOSE_TIME)
    } else {
      setShowTooltip(false)
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [condition])

  return { showTooltip }
}
